/* AMTENDENCY — kit "Sugestões para você".

   Três trabalhos:
   1. abrir/fechar o popup de opções de cada peça e resolver a variante escolhida
   2. somar o Preço Total ao vivo, contando só o que está marcado
   3. mandar tudo de uma vez para `/cart/add.js` e abrir a sacola

   A resolução da variante é feita contra o JSON que o Liquid embutiu: cada
   variante tem `options` na mesma ordem dos fieldsets, então basta comparar as
   listas. Sem isso seria uma requisição por peça só para saber o preço.

   Peça marcada e sem variante disponível não entra no envio — e o botão avisa
   em vez de mandar um id inválido para o carrinho. */
(function () {
  var raiz = document.querySelector('[data-am-kit]');
  if (!raiz) return;

  var itens = [].slice.call(raiz.querySelectorAll('[data-am-kit-item]'));
  var elTotal = raiz.querySelector('[data-am-kit-total]');
  var elAviso = raiz.querySelector('[data-am-kit-aviso]');
  var btn = raiz.querySelector('[data-am-kit-enviar]');

  /* ------------------------------------------------------------------
     Carrossel — 2 cards visíveis em qualquer largura, avançando de um em
     um, sem loop. É a configuração do slick deles:
       slidesToShow: 2   slidesToScroll: 1   infinite: false
     A janela corta, a faixa translada. A largura do slide é calculada em
     px (e não em %) porque a calha muda de 8 para 15px a partir de 1025 —
     em porcentagem a conta erra por uma fração e o último card vaza.
     ------------------------------------------------------------------ */
  var VISIVEIS = 2;
  var janela = raiz.querySelector('[data-am-kit-janela]');
  var faixa = raiz.querySelector('[data-am-kit-faixa]');
  var caixaSetas = raiz.querySelector('[data-am-kit-setas]');
  var btnAnt = raiz.querySelector('[data-am-kit-ant]');
  var btnProx = raiz.querySelector('[data-am-kit-prox]');
  var pagina = 0;

  function maxPagina() {
    return Math.max(0, itens.length - VISIVEIS);
  }

  function medeCarrossel() {
    if (!janela || !faixa) return;
    var largura = janela.clientWidth / VISIVEIS;
    itens.forEach(function (item) {
      item.style.width = largura + 'px';
    });
    faixa.style.width = largura * itens.length + 'px';
    if (pagina > maxPagina()) pagina = maxPagina();
    posiciona();
  }

  function posiciona() {
    if (!janela || !faixa) return;
    var largura = janela.clientWidth / VISIVEIS;
    faixa.style.transform = 'translate3d(' + -(largura * pagina) + 'px, 0, 0)';

    bolas.forEach(function (li, i) {
      li.classList.toggle('am-kit__bola--ativa', i === pagina);
    });

    // `--ativo` marca os cards visíveis: é o gancho do "+" entre os dois
    itens.forEach(function (item, i) {
      var dentro = i >= pagina && i < pagina + VISIVEIS;
      item.classList.toggle('am-kit__item--ativo', dentro);
      // um card fora da janela não deve receber foco por teclado
      item.querySelectorAll('a, button, input').forEach(function (el) {
        if (dentro) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', '-1');
      });
    });

    if (btnAnt) btnAnt.disabled = pagina <= 0;
    if (btnProx) btnProx.disabled = pagina >= maxPagina();
  }

  function vai(passo) {
    pagina = Math.min(maxPagina(), Math.max(0, pagina + passo));
    fechaTodos(null);
    posiciona();
  }

  /* ---- Dots — só aparecem no celular (o CSS esconde a partir de 768px).
     A referência liga o slick com `dots: true` mas no desktop eles não
     rendem; a 390px aparecem: um por página (3 peças, 2 visíveis → 2 dots),
     bolinha de 4px com borda #323232, a ativa preenchida. ---- */
  var bolas = [];
  function montaBolas() {
    if (!janela || maxPagina() < 1) return;
    var lista = document.createElement('ol');
    lista.className = 'am-kit__bolas';
    for (var i = 0; i <= maxPagina(); i++) {
      (function (i) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Ir para a página ' + (i + 1));
        b.addEventListener('click', function () {
          pagina = i;
          fechaTodos(null);
          posiciona();
        });
        li.appendChild(b);
        lista.appendChild(li);
        bolas.push(li);
      })(i);
    }
    // depois da lista de cards, antes do total — onde o slick-dots deles fica
    var listaCards = raiz.querySelector('.am-kit__lista') || janela;
    listaCards.parentNode.insertBefore(lista, listaCards.nextSibling);
  }

  /* ---- Swipe — no celular as setas somem; quem navega é o dedo (e os
     dots). A faixa segue o arrasto e, soltando, encaixa: passou de 1/8 da
     janela, vira página. `touch-action: pan-y` no CSS deixa a rolagem
     vertical com o navegador. ---- */
  function montaArrasto() {
    var arr = null;

    // arrastar uma <img> dispara o drag nativo do navegador e CANCELA os
    // pointer events no meio do gesto — o swipe morria na primeira foto
    janela.addEventListener('dragstart', function (ev) { ev.preventDefault(); });

    janela.addEventListener('pointerdown', function (ev) {
      if (maxPagina() < 1) return;
      arr = { x0: ev.clientX, dx: 0, arrastou: false };
    });

    janela.addEventListener('pointermove', function (ev) {
      if (!arr) return;
      arr.dx = ev.clientX - arr.x0;
      if (!arr.arrastou && Math.abs(arr.dx) > 8) {
        arr.arrastou = true;
        fechaTodos(null);
        faixa.style.transition = 'none';
        // sem isto o gesto com mouse sai selecionando texto pelo caminho
        janela.style.userSelect = 'none';
        // sem isto o navegador "pega" o ponteiro para si no meio do gesto
        if (janela.setPointerCapture && ev.pointerId !== undefined) {
          try { janela.setPointerCapture(ev.pointerId); } catch (e) {}
        }
      }
      if (arr.arrastou) {
        var largura = janela.clientWidth / VISIVEIS;
        var base = -(largura * pagina);
        // nas pontas o arrasto endurece, como no slick (metade do gesto)
        var dx = arr.dx;
        if ((pagina <= 0 && dx > 0) || (pagina >= maxPagina() && dx < 0)) dx = dx / 2;
        faixa.style.transform = 'translate3d(' + (base + dx) + 'px, 0, 0)';
      }
    });

    function solta() {
      if (!arr) return;
      var foi = arr;
      arr = null;
      faixa.style.transition = '';
      janela.style.userSelect = '';
      if (!foi.arrastou) return;
      var limiar = janela.clientWidth / 8;
      if (foi.dx <= -limiar) pagina = Math.min(maxPagina(), pagina + 1);
      else if (foi.dx >= limiar) pagina = Math.max(0, pagina - 1);
      posiciona();
      // o clique que nasce no fim do arrasto não deve abrir nada
      janela.addEventListener('click', function mata(ev) {
        ev.stopPropagation();
        ev.preventDefault();
        janela.removeEventListener('click', mata, true);
      }, true);
    }
    janela.addEventListener('pointerup', solta);
    janela.addEventListener('pointercancel', solta);
  }

  if (janela && faixa) {
    faixa.dataset.amKitPronto = '1';
    if (caixaSetas) caixaSetas.hidden = itens.length <= VISIVEIS;
    if (btnAnt) btnAnt.addEventListener('click', function () { vai(-1); });
    if (btnProx) btnProx.addEventListener('click', function () { vai(1); });
    montaBolas();
    montaArrasto();
    medeCarrossel();
    // as fotos entram depois e mudam a altura da faixa; o `load` reajusta
    window.addEventListener('resize', medeCarrossel);
    window.addEventListener('load', medeCarrossel);
  }

  function moeda(centavos) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL',
      }).format(centavos / 100);
    } catch (e) {
      return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',');
    }
  }

  function estado(item) {
    var fixo = item.querySelector('[data-am-kit-variante]');
    if (fixo) return { id: Number(fixo.value), preco: null, disponivel: true, quantidade: null };

    var dados = item.querySelector('[data-am-kit-variantes]');
    if (!dados) return null;
    var variantes;
    try {
      variantes = JSON.parse(dados.textContent);
    } catch (e) {
      return null;
    }

    var escolhido = [].slice
      .call(item.querySelectorAll('[data-am-kit-opcao]'))
      .filter(function (r) {
        return r.checked;
      })
      .sort(function (a, b) {
        return Number(a.dataset.amKitOpcao) - Number(b.dataset.amKitOpcao);
      })
      .map(function (r) {
        return r.value;
      });

    for (var i = 0; i < variantes.length; i++) {
      var v = variantes[i];
      var bate = v.options.length === escolhido.length;
      for (var j = 0; bate && j < v.options.length; j++) {
        if (v.options[j] !== escolhido[j]) bate = false;
      }
      if (bate) {
        return {
          id: v.id,
          preco: v.price,
          disponivel: !!v.available,
          // `inventory_quantity` só vem quando a loja expõe o estoque
          quantidade: typeof v.inventory_quantity === 'number' ? v.inventory_quantity : null,
        };
      }
    }
    return { id: null, preco: null, disponivel: false, quantidade: null };
  }

  function pinta(item) {
    var e = estado(item);
    if (!e) return null;

    var preco = item.querySelector('[data-am-kit-preco]');
    if (preco && e.preco !== null) preco.textContent = moeda(e.preco);

    var esg = item.querySelector('[data-am-kit-esgotado]');
    if (esg) esg.hidden = e.disponivel;

    // "ÚLTIMA UNIDADE DISPONÍVEL": só com a variante disponível e no fim
    var est = item.querySelector('[data-am-kit-estoque]');
    if (est) {
      var pouco = e.disponivel && e.quantidade !== null && e.quantidade > 0 && e.quantidade <= 1;
      est.hidden = !pouco;
      if (pouco) est.textContent = est.dataset.amKitEstoqueTexto || 'ÚLTIMA UNIDADE DISPONÍVEL';
    }

    // espelha o valor escolhido no rótulo do fieldset ("Tamanho: M")
    [].slice.call(item.querySelectorAll('[data-am-kit-opcao]')).forEach(function (r) {
      if (!r.checked) return;
      var alvo = item.querySelector('[data-am-kit-valor="' + r.dataset.amKitOpcao + '"]');
      if (alvo) alvo.textContent = r.value;
    });

    return e;
  }

  function soma() {
    var total = 0;
    var algum = false;
    var marcados = 0;
    itens.forEach(function (item) {
      var check = item.querySelector('[data-am-kit-check]');
      var e = pinta(item);
      item.classList.toggle('is-off', !(check && check.checked));
      if (!check || !check.checked || !e || !e.disponivel) return;
      marcados += 1;
      algum = true;
      if (e.preco !== null) total += e.preco;
      else {
        // peça de variante única: o preço já está impresso no card
        var txt = item.querySelector('[data-am-kit-preco]');
        var n = txt ? Number(String(txt.textContent).replace(/\D/g, '')) : 0;
        total += n;
      }
    });
    elTotal.textContent = algum ? moeda(total) : '—';
    btn.disabled = !algum;

    // "Adicionar (2) item ao carrinho": a contagem entra no lugar do {n}
    var molde = btn.dataset.molde;
    if (molde) btn.textContent = molde.replace('{n}', String(marcados));
  }

  function fechaTodos(menos) {
    itens.forEach(function (item) {
      if (item === menos) return;
      var pop = item.querySelector('[data-am-kit-popup]');
      var abrir = item.querySelector('[data-am-kit-abrir]');
      if (pop) pop.hidden = true;
      if (abrir) abrir.setAttribute('aria-expanded', 'false');
    });
  }

  raiz.addEventListener('click', function (ev) {
    var abrir = ev.target.closest && ev.target.closest('[data-am-kit-abrir]');
    if (abrir) {
      var item = abrir.closest('[data-am-kit-item]');
      var pop = item.querySelector('[data-am-kit-popup]');
      var estavaAberto = !pop.hidden;
      fechaTodos(item);
      pop.hidden = estavaAberto;
      abrir.setAttribute('aria-expanded', String(!estavaAberto));
      return;
    }
    if (ev.target.closest && ev.target.closest('[data-am-kit-fechar]')) {
      fechaTodos(null);
    }
  });

  raiz.addEventListener('change', function (ev) {
    if (ev.target.matches('[data-am-kit-check], [data-am-kit-opcao]')) soma();
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') fechaTodos(null);
  });

  btn.addEventListener('click', function () {
    var pecas = [];
    itens.forEach(function (item) {
      var check = item.querySelector('[data-am-kit-check]');
      if (!check || !check.checked) return;
      var e = estado(item);
      if (e && e.id && e.disponivel) pecas.push({ id: e.id, quantity: 1 });
    });
    if (!pecas.length) return;

    btn.disabled = true;
    elAviso.hidden = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: pecas }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('carrinho');
        return r.json();
      })
      .then(function () {
        var gaveta = document.querySelector('cart-drawer');
        // a gaveta busca as seções sozinha ao abrir; sem ela, vai para /cart
        if (gaveta && typeof gaveta.open === 'function') {
          document.dispatchEvent(new CustomEvent('am:carrinho-mudou'));
          gaveta.classList.remove('is-empty');
          gaveta.open(btn);
          fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
            .then(function (r) {
              return r.text();
            })
            .then(function (html) {
              var novo = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
              if (novo) gaveta.innerHTML = novo.innerHTML;
            })
            .catch(function () {});
        } else {
          window.location = window.Shopify.routes.root + 'cart';
        }
      })
      .catch(function () {
        elAviso.hidden = false;
        elAviso.textContent = 'Não deu para adicionar agora. Tente de novo.';
      })
      .finally(function () {
        btn.disabled = false;
      });
  });

  soma();
})();
